(function () {
  'use strict';

  function initSection(section) {
    if (!section || section.dataset.thsInitialized === 'true') return;

    section.dataset.thsInitialized = 'true';
  }

  function initAll(root) {
    var scope = root || document;

    if (
      scope.nodeType === 1 &&
      scope.matches &&
      scope.matches('.toqui-how-support')
    ) {
      initSection(scope);
    }

    if (scope.querySelectorAll) {
      scope
        .querySelectorAll('.toqui-how-support')
        .forEach(initSection);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
